module.exports = __webpack_public_path__ + "static/img/eyes_02.410fa40.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_02.png
// module id = V+bK
// module chunks = 0